// PromotionsMarketing.js
import { Outlet, useLocation, Navigate, useNavigate } from "react-router-dom";
import "./PromotionsMarketing.css";

// MUI Icons
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import CampaignIcon from "@mui/icons-material/Campaign";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import PeopleIcon from "@mui/icons-material/People";

const PromotionsMarketing = () => {
  const location = useLocation();
  const path = location.pathname.split("/").pop();
  const navigate = useNavigate();

  const tabs = [
    { key: "promotions", label: "Promotions", icon: <LocalOfferIcon /> },
    { key: "banners", label: "Featured Stores", icon: <CampaignIcon /> },
    {
      key: "announcements",
      label: "Push Notifications",
      icon: <NotificationsActiveIcon />,
    },
    { key: "referrals", label: "Referral Program", icon: <PeopleIcon /> },
  ];

  const getTitle = () => {
    const found = tabs.find((t) => t.key === path);
    return found ? found.label : "Promotions & Marketing";
  };

  return (
    <div className="promotions-container">
      <div className="data_head">
        <h1 className="data_heading">{getTitle()}</h1>
        {/* optional global actions */}
      </div>

      <div className="promotions-content">
        <Outlet />
      </div>
    </div>
  );
};

export default PromotionsMarketing;
